import { Pagination } from "@mui/material";
import {
  CalendarIcon,
  Cross2Icon,
  DownloadIcon,
  Pencil1Icon,
  PersonIcon,
  SewingPinFilledIcon
} from "@radix-ui/react-icons";
import { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { checkTagValidity, months, years } from "../../Utils/Utils";
import { BASE_URL, BORDEREAU_LIVRAISON, FICHIER_DOWNLOAD, LIST_LIVRAISON } from "../../Utils/constant";
import { Abonnement } from "../../components/Abonnement/Abonnement";
import { UpdateLivraisonForm } from "../../components/Livraison/UpdateLivraisonForm";
import { ContentLoading } from "../../components/Widget/ContentLoading";
import { Pbo } from "../../components/Widget/Pbo";
import { Tabs } from "../../components/Widget/Tab";
import { useStoreLivraison } from "../../store/livraisonStore";

const Livraisons = () => {
  const [selectItem, setSelectItem] = useState(null)
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [select, setSelect] = useState("ANNEE");
  const [active, setActive] = useState(
    {
      index: 0,
      value: 'En attente de livraison',
      tag: 'LISTE_EN_ATTENTE_LIVRAISON'
    }
  );

  const more = (page) => {
    store.getData(LIST_LIVRAISON, { page: page - 1, param: "", size: 10 }, '&periode=&mois=&annee=&dateDebut=&dateFin=')
  };

  const listeTabsData = [{
    index: 0,
    value: 'En attente de livraison',
    tag: 'LISTE_EN_ATTENTE_LIVRAISON'
  },
  {
    index: 1,
    value: 'Intention livré',
    tag: 'LISTE_LIVRER'
  }]

  const filteredTabsData = listeTabsData
    .filter((tab) => checkTagValidity(tab.tag))
    .map((tab, index) => ({ ...tab, index }));

  useEffect(() => {
    if (filteredTabsData.length !== 0) {
      setActive(filteredTabsData[0])
    }
  }, []);

  const store = useStoreLivraison()
  useEffect(() => {
    store.getData(LIST_LIVRAISON, { page: 0, param: "", size: 10 }, '&periode=&mois=&annee=&dateDebut=&dateFin=')
  }, [])

  return (
    <div className="">
      <div className="lg:flex gap-8 items-center">
        <h3 class="text-3xl font-bold font-mtn">Livraisons</h3>
        <div className="ml-auto lg:flex gap-x-3">
          <select
            onChange={(e) => {
              setSelect(e.target.value);
            }}
            className="my-2 select"
          >
            <option>Periode</option>
            <option value="MOIS">Filtre par mois</option>
            <option value="ANNEE" selected>
              Filtre par années
            </option>
          </select>
          {select === "MOIS" ? (
            <select onChange={(e) => { }} className="my-2 select">
              <option disabled selected>
                mois
              </option>
              {months.map((item) => (
                <option value={item.code}>{item.name}</option>
              ))}
            </select>
          ) : select === "ANNEE" ? (
            <select onChange={(e) => { }} className="my-2 select ">
              <option disabled selected>
                années
              </option>
              {years.map((item) => (
                <option
                  value={item.name}
                  selected={
                    new Date().getFullYear() === Number(item.name)
                      ? true
                      : false
                  }
                >
                  {item.name}
                </option>
              ))}
            </select>
          ) : (
            <ReactDatePicker
              dateFormat="dd-MM-yyyy"
              selected={startDate}
              onChange={(update) => {
                if (update[1] != null) {
                }
                setDateRange(update);
              }}
              startDate={startDate}
              endDate={endDate}
              selectsRange
              className="text-xs font-normal cursor-pointer btn btn-sm hover:bg-gray-100 text-center h-8 my-2 w-52 rounded-md border border-input bg-gray-100 px-3 py-1 shadow-sm"
            />
          )}
        </div>
      </div>
      <dialog id="livraison" className="modal rounded-none">
        <div className="modal-box max-w-2xl">
          <div className="modal-action">
            <h1 className='mr-auto text-2xl font-bold font-mtn'>
              Details de la livraison
            </h1>
            <form method="dialog">
              <button id='detail' className="btn btn-sm"><Cross2Icon /></button>
            </form>
          </div>
          <div className="p-3 rounded-lg">
            <div className="px-4 sm:px-0">
              <h3 className="lg:text-sm font-bold text-2xl text-gray-900">
                Information sur la livraison
              </h3>
            </div>

            <div className="mt-2 border-t border-gray-100">
              <dl className="divide-y divide-gray-100">
                <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                  <dt className="text-sm font-medium leading-6 text-gray-900">
                    Date de livraison
                  </dt>
                  <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                    {new Date(selectItem?.dateLivraison).toLocaleString()}
                  </dd>
                </div>
              </dl>
            </div>

            <div className="mt-2 border-t border-gray-100">
              <dl className="divide-y divide-gray-100">
                <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                  <dt className="text-sm font-medium leading-6 text-gray-900">
                    Numero de ticket
                  </dt>
                  <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                    {selectItem?.eligibilite?.numeroTicket}
                  </dd>
                </div>
              </dl>
            </div>

            <div className="mt-2 border-t border-gray-100">
              <dl className="divide-y divide-gray-100">
                <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                  <dt className="text-sm font-medium leading-6 text-gray-900">
                    Forfait
                  </dt>
                  <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                    {selectItem?.forfait}
                  </dd>
                </div>
              </dl>
            </div>

            <div className="mt-2 border-t border-gray-100">
              <dl className="divide-y divide-gray-100">
                <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                  <dt className="text-sm font-medium leading-6 text-gray-900">
                    Numero de serie
                  </dt>
                  <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                    {selectItem?.numeroSerie}
                  </dd>
                </div>
              </dl>
            </div>

            <div className="mt-2 border-t border-gray-100">
              <dl className="divide-y divide-gray-100">
                <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                  <dt className="text-sm font-medium leading-6 text-gray-900">
                    Numero FTTH
                  </dt>
                  <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                    {selectItem?.numeroFtth}
                  </dd>
                </div>
              </dl>
            </div>

            <h3 className="font-bold my-2 lg:text-sm text-2xl text-gray-900">
              Information sur le client
            </h3>
            <div className="mt-2 border-t border-gray-100">
              <dl className="divide-y divide-gray-100">
                <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                  <dt className="text-sm font-medium leading-6 text-gray-900">
                    Nom et prenoms
                  </dt>
                  <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                    {selectItem?.client?.nomPrenoms}
                  </dd>
                </div>
              </dl>
            </div>

            <div className="mt-2 border-t border-gray-100">
              <dl className="divide-y divide-gray-100">
                <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                  <dt className="text-sm font-medium leading-6 text-gray-900">
                    Numero
                  </dt>
                  <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                    {selectItem?.client?.numero}
                  </dd>
                </div>
              </dl>
            </div>

            <div className="mt-2 border-t border-gray-100">
              <dl className="divide-y divide-gray-100">
                <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                  <dt className="text-sm font-medium leading-6 text-gray-900">
                    Type de client
                  </dt>
                  <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                    {selectItem?.client?.typeClient}
                  </dd>
                </div>
              </dl>
            </div>

            <h3 className="font-bold my-4 lg:text-sm text-2xl text-gray-900">
              Information sur l'agent
            </h3>

            <div className="mt-2 border-t border-gray-100">
              <dl className="divide-y divide-gray-100">
                <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                  <dt className="text-sm font-medium leading-6 text-gray-900">
                    Nom et prenoms
                  </dt>
                  <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                    {selectItem?.agent?.nomPrenoms}
                  </dd>
                </div>
              </dl>
            </div>

            <div className="mt-2 border-t border-gray-100">
              <dl className="divide-y divide-gray-100">
                <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                  <dt className="text-sm font-medium leading-6 text-gray-900">
                    Numero
                  </dt>
                  <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                    {selectItem?.agent?.numero}
                  </dd>
                </div>
              </dl>
            </div>

            <h3 className="my-2 lg:text-sm font-bold text-2xl text-gray-900">
              Bordereau de livraison
            </h3>
            <div>
              <div style={{ backgroundImage: `url("${BASE_URL}/webfree/fichier/${selectItem?.bordereauLivraison?.id}")`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}
                className="bg-gray-200 rounded-lg w-96 h-44 border-2 mt-5 flex items-center justify-center">
                {checkTagValidity("TELECHARGER") ?
                  <a href={`${BASE_URL + BORDEREAU_LIVRAISON}/${selectItem?.id}`} target="_blank"
                    className="gap-1 bg-white text-gray-600 font-medium h-9 flex items-center rounded-lg px-3 text-xs" rel="noreferrer"
                  >
                    <DownloadIcon /> Telecharger le {selectItem?.bordereauLivraison?.typeFichier?.replace(/_/g, " ").toLowerCase()}
                  </a>
                  : null}
              </div>
            </div>

            <h3 className="my-2 lg:text-sm font-bold text-2xl text-gray-900">
              Liste des pieces du client
            </h3>

            <div className="grid grid-cols-2 gap-x-1">
              {
                selectItem?.listPieces?.map((item, index) => (
                  <div>
                    <div style={{ backgroundImage: `url("${BASE_URL}/webfree/fichier/${item.id}")`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}
                      className="bg-gray-200 rounded-lg border-2 h-52 mx-auto flex items-center justify-center">
                      <a href={`${BASE_URL + FICHIER_DOWNLOAD}/${item?.id}?filename=Pieces_Identite_${index === 1 ? 'recto' : 'verso'}`} target="_blank"
                        className="gap-1 bg-white text-gray-600 font-medium h-9 flex items-center rounded-lg px-3 text-xs" rel="noreferrer"
                      >
                        <DownloadIcon /> Telecharger la piece {item.typeFichier?.replace(/_/g, " ").toLowerCase()}
                      </a>
                      <p className='text-xs bg-white font-bold p-1 rounded'></p>
                    </div>
                  </div>
                ))
              }
            </div>

          </div>
        </div>
      </dialog>


      <dialog id="edit" className="modal rounded-none">
        <div className="modal-box max-w-2xl">
          <div className="modal-action">
            <h1 className='mr-auto text-2xl font-bold font-mtn'>
              Modification
            </h1>
            <form method="dialog">
              <button id='detail' className="btn btn-sm"><Cross2Icon /></button>
            </form>
          </div>
          <UpdateLivraisonForm item={selectItem} />
        </div>
      </dialog>

      <div className="bg-white rounded-md px-2 py-4 mt-3">
        {filteredTabsData.length !== 0 ? <Tabs tabsData={filteredTabsData} active={active} setActive={setActive} /> : null}
        {
          active.index === 0 ? (
            <Abonnement status={'EN_ATTENTE_DE_LIVRAISON'} perm={'POURSUIVRE_LIVRAISON'} step={3} />
          ) : active.index === 1 ? (
            <>
              <div>
                <div className="mt-3 flex gap-1">
                  <input
                    onChange={(e) => store.getData(LIST_LIVRAISON, { page: 0, param: e.target.value, size: 10 }, '&periode=&mois=&annee=&dateDebut=&dateFin=')
                    }
                    type="text"
                    placeholder="Rechercher element..."
                    className="text-xs input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
                  />
                </div>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-2 my-4">
                  {store?.data?.data?.length === 0 ?
                    <div className="flex justify-center items-center">
                      <img src="" alt="" srcset="" />
                    </div>
                    :
                    store?.data?.data?.length !== 0 && !store?.loading ?
                      store?.data?.data?.map((item) => (
                        <div className="relative bg-white rounded-xl border-slate-200 border shadow-sm">
                          <div className="rounded-t-xl flex items-center gap-3 border-b-[2px] border-orange-100 px-2 py-3">
                            <p className="text-[12px] font-semibold">{item.eligibilite.numeroTicket}</p>
                          </div>
                          <div className=" px-3 py-2 ">
                            <div className="my-1 flex items-center">
                              <div className="flex items-center gap-2">
                                <div className={`px-3 border  rounded-full py-1 text-xs text-green-600 font-semibold`}>
                                  {item?.status.toLowerCase()}
                                </div>
                                <Pbo pbo={item?.eligibilite?.pbo?.nom} port={item?.brin} />
                              </div>
                            </div>
                            <h1 className="text-xs flex gap-1 items-center my-2">
                              Forfait :{" "}
                              {item?.forfait}
                            </h1>
                            <div className="items-center gap-2 space-y-3">
                              <h1 className="text-[14px] font-bold flex items-center">
                                <SewingPinFilledIcon />
                                {item.commune + ", " + item.quartier}
                              </h1>
                              <div className="pb-3 border-b flex gap-4 items-center">
                                <p className="text-xs flex gap-1 items-center font-medium">
                                  <CalendarIcon />
                                  {new Date(item.dateLivraison).toLocaleString()}
                                </p>
                              </div>
                              <div className="flex gap-1 ">
                                <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                                <div>
                                  <p className="text-[13px] font-medium">{item?.agent?.nomPrenoms}</p>
                                  <p className="text-xs flex font-semibold gap-2">
                                    <span>{item?.agent?.numero}</span> {" | "}{" "}
                                    <span>{item?.agent?.email}</span>{" "}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="flex items-center">
                              <button onClick={() => {
                                setSelectItem(item)
                                document.getElementById('livraison').showModal()
                              }} className='btn btn-sm bg-main text-xs my-2'>Details de livraison</button>
                              <button
                                onClick={() => {
                                  setSelectItem(item);
                                  document.getElementById("edit").showModal();
                                }}
                                className=" text-white text-xs btn btn-sm bg-black"
                              >
                                <Pencil1Icon /> Modifier
                              </button>
                            </div>

                          </div>
                        </div>
                      ))
                      :
                      <ContentLoading />
                  }

                </div>
              </div>
              <div className="my-3 flex justify-end">
                <Pagination
                  onChange={(event, newValue) => more(newValue)}
                  onSelect={(selectedPage) => more(selectedPage)}
                  count={store?.data?.totalPages}
                  variant="outlined"
                  color="primary"
                  shape="rounded"
                />
              </div>
            </>
          ) : null
        }





      </div>
    </div >
  );
};

export default Livraisons;
